up.compiler('[trash-record-button]', (element) => {
  let input = element.querySelector('input')
  let target = element.getAttribute('target') || '.content'
  input.removeAttribute('disabled')

  function toggleValue() {
    if (input.getAttribute('value') === 'true') {
      input.setAttribute('value', false)
    } else {
      if (confirm( element.title + "?")) {
        input.setAttribute('value', true)
      }
    }

    let form = element.closest('form')
    up.validate(form, { target: target })
  }

  element.addEventListener('click', function() {
    toggleValue()
  })

})
